export enum UsersErrorCodes {
    ACCOUNT_PREFERENCE_NOT_FOUND = 2040,
    ACCOUNT_ADDRESS_DEFAULT_DELETE = 2180,
    ACCOUNT_ADDRESS_LAST_DELETE = 2190,
}
